var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 130
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 0H0V130H130V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#F0B29B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 40.25V47C96 53.2156 81.8953 58.25 64.5 58.25C47.1047 58.25 33 53.2156 33 47V40.25C33 34.0344 47.1047 29 64.5 29C81.8953 29 96 34.0344 96 40.25ZM88.2938 59.1922C91.2188 58.1516 93.9047 56.8156 96 55.1703V69.5C96 75.7156 81.8953 80.75 64.5 80.75C47.1047 80.75 33 75.7156 33 69.5V55.1703C35.0953 56.8297 37.7812 58.1516 40.7062 59.1922C47.0203 61.4422 55.4297 62.75 64.5 62.75C73.5703 62.75 81.9797 61.4422 88.2938 59.1922ZM33 77.6703C35.0953 79.3297 37.7812 80.6516 40.7062 81.6922C47.0203 83.9422 55.4297 85.25 64.5 85.25C73.5703 85.25 81.9797 83.9422 88.2938 81.6922C91.2188 80.6516 93.9047 79.3156 96 77.6703V89.75C96 95.9656 81.8953 101 64.5 101C47.1047 101 33 95.9656 33 89.75V77.6703Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 72,
    fill: "white",
    transform: "translate(33 29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomData);
export default __webpack_public_path__ + "static/media/customData.145d65b5e10a5b9586b294bb27121185.svg";
export { ForwardRef as ReactComponent };